import { GLU_Campaign } from "../types";
import {
  GLU_GET_CAMPAIGNS_LIST_FAILURE,
  GLU_GET_CAMPAIGNS_LIST_REQUEST,
  GLU_GET_CAMPAIGNS_LIST_SUCCESS,
} from "../../../Redux/Actions/GLUActions";

const initialState = {
  campaignsList: [] as GLU_Campaign[],
  isLoading: false,
  error: "",
};

export const campaignsListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GLU_GET_CAMPAIGNS_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: "",
      };
    case GLU_GET_CAMPAIGNS_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        campaignsList: action.payload,
      };
    case GLU_GET_CAMPAIGNS_LIST_FAILURE:
      return {
        campaignsList: {},
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
